// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getFunctions, httpsCallable } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAqITuHdKJqz0KPC5vhUfD-50JYxFfyGus",
  authDomain: "orders-confirmation-2c963.firebaseapp.com",
  projectId: "orders-confirmation-2c963",
  storageBucket: "orders-confirmation-2c963.firebasestorage.app",
  messagingSenderId: "49350052043",
  appId: "1:49350052043:web:ef84416f6d2a40419eb34e",
  measurementId: "G-7R1SNH9L8P",
  databaseURL: "https://orders-confirmation-2c963-default-rtdb.europe-west1.firebasedatabase.app"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Realtime Database
export const rtDb = getDatabase(app);

// Initialize Functions
const functions = getFunctions(app);

/**
 * Call createNewClient Cloud Function
 * @param {object} clientData - Client data from signup form
 * @returns {Promise<object>} - Response from function
 */
export const callCreateNewClient = async (clientData) => {
  try {
    const createNewClientFunction = httpsCallable(functions, 'createNewClient');
    const result = await createNewClientFunction(clientData);
    return result.data;
  } catch (error) {
    console.error("Error calling createNewClient function:", error);
    throw new Error(error.message); 
  }
};

/**
 * Call sendManualMessage Cloud Function
 * إرسال رسالة يدوية من صاحب البراند للعميل عبر WhatsApp
 * @param {object} messageData - { orderId, clientId, message }
 * @returns {Promise<object>} - Response from function
 */
export const callSendManualMessage = async (messageData) => {
  try {
    const sendManualMessageFunction = httpsCallable(functions, 'sendManualMessage');
    const result = await sendManualMessageFunction(messageData);
    return result.data;
  } catch (error) {
    console.error("Error calling sendManualMessage function:", error);
    
    // استخراج رسالة الخطأ
    let errorMessage = error.message;
    if (error.code === 'functions/failed-precondition') {
      errorMessage = error.message.replace('failed-precondition: ', '');
    }
    
    throw new Error(errorMessage);
  }
};

/**
 * Call answerCustomerQuestion Cloud Function
 * الرد على سؤال عميل مع إرسال الرد عبر واتساب وتحديث الداتا
 * @param {object} answerData - { questionId, answerText, addToKnowledge }
 * @returns {Promise<object>} - Response from function
 */
export const callAnswerCustomerQuestion = async (answerData) => {
  try {
    console.log('🚀 Calling answerCustomerQuestion with:', answerData);
    const answerCustomerQuestionFunction = httpsCallable(functions, 'answerCustomerQuestion');
    const result = await answerCustomerQuestionFunction(answerData);
    console.log('✅ Function response:', result.data);
    return result.data;
  } catch (error) {
    console.error("❌ Error calling answerCustomerQuestion function:", error);
    
    // استخراج رسالة الخطأ
    let errorMessage = error.message;
    if (error.code === 'functions/failed-precondition') {
      errorMessage = error.message.replace('failed-precondition: ', '');
    }
    
    throw new Error(errorMessage);
  }
};

export default app;

